// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__LhDIu","arrow":"Breadcrumbs_arrow__0CZ5t","active":"Breadcrumbs_active__MU0lF"};